<template>
  <div class="edit-org-name-box">
    <cube-form
      :model="model"
      @validate="validateHandler"
      @submit.prevent="submitHandler"
      @reset="resetHandler"
    >
      <cube-form-item>
        <div class="cube-form-tip-box">
          <h3>{{ $t('message["1582"]') }}  {{ this.$route.query.comname }}</h3>
          <p> {{ $t('message["518"]') }}。</p>
        </div>
      </cube-form-item>
      <template v-if="!$isDingDing">
        <cube-form-item :field="fields[0]" />
        <!-- <captcha-input
          v-model="model.captcha"
          label="图片验证码"
        /> -->
        <div class="cube-form-item-box">
          <cube-form-item :field="fields[1]" />
          <div class="find-pwd-box">
            <get-code
              class="find-pwd-link"
              :mobile="mobile"
              type="12"
              :is-disabled="false"
            />
          </div>
        </div>
      </template>
      <div class="form-btn-box">
        <cube-button
          :light="true"
          type="reset"
        >
          {{ $t('message["896"]') }}
        </cube-button>
        <cube-button
          v-if="!$isDingDing"
          type="submit"
          :primary="true"
        >
          解散
        </cube-button>
        <cube-button
          v-else
          type="submit"
          :primary="true"
          @click="submitHandler"
        >
          {{ $t('message["517"]') }}
        </cube-button>
      </div>
    </cube-form>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import GetCode from '@/components/mobile/GetCode'
// import CaptchaInput from '@/components/mobile/CaptchaInput'

export default {
  components: {
    GetCode
  },
  data () {
    return {
      validity: {},
      valid: undefined,
      model: {
        mobile: this.$route.query.mobile.substring(0, 3) + '****' + this.$route.query.mobile.substring(7, 11),
        checkcode: '',
        captcha: ''
      },
      options: {
        scrollToInvalidField: true,
        layout: 'fresh' // classic fresh
      },
      fields: [
        {
          type: 'input',
          modelKey: 'mobile',
          label: this.$t('message["1116"]'),
          props: {
            placeholder: '',
            disabled: true
          },
          rules: {
            required: true
          }
        },
        {
          type: 'input',
          modelKey: 'checkcode',
          label: '',
          props: {
            placeholder: this.$t('message["824"]')
          },
          rules: {
            required: true
          }
        }
      ]
    }
  },
  computed: {
    mobile () {
      return this.$route.query.mobile
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions('organization/org', ['ajaxDismissOrg']),
    async submitHandler (e) {
      let obj = {}
      const chain = await this.ajaxDismissOrg()
      this.model.mobile = this.mobile
      obj = Object.assign(this.model, { cid: this.$route.query.cid })
      chain.params(obj)
        .onSuccess(raw => {
          this.$router.push({
            name: 'OrgIndex',
            query: {
              page: 1
            } })
        })
        .onNetSuccess((res) => {
          const toast = this.$createToast({
            time: 2000,
            txt: res.data.message || res.data.payload[0].message,
            type: 'txt'
          })
          toast.show()
        })
        .config({ tip: false })
        .fetch()
    },
    validateHandler (result) {
      this.validity = result.validity
      this.valid = result.valid
    },
    resetHandler () {
      this.$router.push({
        name: 'OrgIndex',
        query: {
          page: 1
        } })
    }
  }
}
</script>
<style lang="scss" scoped>
.edit-org-name-box::v-deep {
    .cube-form-item {
      min-height: 56px;
      line-height: 56px;
      .cube-form-label {
        color: #888;
      }
    }
    .cube-form-item-box .find-pwd-box {
      top: 16px;
    }
  }
</style>
